export class ErrorCodes {
    static readonly accountNotFound: string = "AccountNotFound";
    static readonly invalidEnvironment: string = 'InvalidEnvironment';
}